import { render } from "./AppInput.vue?vue&type=template&id=b36163c8"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__